var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g, _rect7, _circle, _circle2, _circle3, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _path, _rect26, _rect27, _rect28, _rect29, _rect30, _path2, _path3, _path4, _path5, _rect31, _rect32, _rect33, _rect34, _circle4, _path6, _path7, _path8, _path9, _rect35, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _circle5, _circle6, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _circle7, _circle8, _circle9, _circle10, _rect36, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _circle11, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _circle12, _path103, _path104, _path105, _path106;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 536,
    height: 597,
    viewBox: "0 0 536 597",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    width: 124,
    height: 125,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 18,
    width: 53,
    height: 7,
    fill: "#DDDDED"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 29,
    width: 53,
    height: 1,
    fill: "#DDDDED"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 36,
    width: 53,
    height: 1,
    fill: "#DDDDED"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 64,
    width: 41,
    height: 4,
    fill: "#DDDDED"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 83,
    width: 41,
    height: 4,
    fill: "#DDDDED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.8652,
    y: 15,
    width: 7.26923,
    height: 27,
    fill: "#E8505B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 32.134,
    width: 7.26923,
    height: 27,
    transform: "rotate(-90 70 32.134)",
    fill: "#E8505B"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 103,
    width: 41,
    height: 4,
    fill: "#DDDDED"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 82,
    cy: 66,
    r: 4,
    fill: "#E8505B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 82,
    cy: 85,
    r: 4,
    fill: "#E8505B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 82,
    cy: 104,
    r: 4,
    fill: "#E8505B"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    width: 124,
    height: 125,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 395,
    y: 18,
    width: 20,
    height: 7,
    fill: "#DDDDED"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 18,
    width: 20,
    height: 7,
    fill: "#DDDDED"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 18,
    width: 20,
    height: 7,
    fill: "#DDDDED"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 395,
    y: 29,
    width: 20,
    height: 1,
    fill: "#DDDDED"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 91,
    width: 51,
    height: 2,
    fill: "#DDDDED"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 70,
    width: 51,
    height: 2,
    fill: "#DDDDED"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 29,
    width: 20,
    height: 1,
    fill: "#DDDDED"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 29,
    width: 20,
    height: 1,
    fill: "#DDDDED"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 395,
    y: 36,
    width: 20,
    height: 1,
    fill: "#DDDDED"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 98,
    width: 51,
    height: 2,
    fill: "#DDDDED"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 77,
    width: 51,
    height: 2,
    fill: "#DDDDED"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 63,
    width: 51,
    height: 2,
    fill: "#DDDDED"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 105,
    width: 51,
    height: 2,
    fill: "#DDDDED"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 84,
    width: 51,
    height: 2,
    fill: "#DDDDED"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 36,
    width: 20,
    height: 1,
    fill: "#DDDDED"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 424,
    y: 63,
    width: 41,
    height: 4,
    fill: "#DDDDED"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 443,
    y: 100,
    width: 22,
    height: 7,
    fill: "#E8505B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M364 20.9055L374.005 18L384 20.9055V26.864C384 33.1269 379.972 38.6869 374.001 40.6667C368.029 38.6869 364 33.1257 364 26.8613V20.9055Z",
    fill: "#ED737C"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 201,
    width: 37,
    height: 52,
    fill: "white"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 12,
    width: 25,
    height: 1,
    fill: "#DDDDED"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 7,
    width: 25,
    height: 1,
    fill: "#DDDDED"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 38,
    width: 25,
    height: 1,
    fill: "#DDDDED"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 209,
    y: 23,
    width: 22,
    height: 7,
    fill: "#E8505B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201 5C203.761 5 206 2.76142 206 0H201V5Z",
    fill: "#DDDDED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201 47C203.761 47 206 49.2386 206 52H201V47Z",
    fill: "#DDDDED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238 5C235.239 5 233 2.76142 233 0H238V5Z",
    fill: "#DDDDED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238 47C235.239 47 233 49.2386 233 52H238V47Z",
    fill: "#DDDDED"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 258,
    width: 74,
    height: 52,
    fill: "white"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 10,
    width: 53,
    height: 2,
    fill: "#DDDDED"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 18,
    width: 33,
    height: 2,
    fill: "#DDDDED"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 39,
    width: 30,
    height: 2,
    fill: "#DDDDED"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 274,
    cy: 38,
    r: 6,
    fill: "#E8505B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258 5C260.761 5 263 2.76142 263 0H258V5Z",
    fill: "#DDDDED"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258 47C260.761 47 263 49.2386 263 52H258V47Z",
    fill: "#DDDDED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332 5C329.239 5 327 2.76142 327 0H332V5Z",
    fill: "#DDDDED"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332 47C329.239 47 327 49.2386 327 52H332V47Z",
    fill: "#DDDDED"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 423,
    y: 192,
    width: 30,
    height: 44,
    fill: "#CABCE8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M109.743 523.574L131.888 521.842L131.193 543.321L110.222 544.42L109.743 523.574Z",
    fill: "#FFBE9D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9817 519.285L37.5105 520.98L33.6942 540.54L14.333 538.44L16.9817 519.285Z",
    fill: "#FFBE9D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1865 526.156C20.9962 469.414 44.7747 354.247 55.9788 302.375C81.4932 288.298 134.319 270.454 141.508 311.685C148.696 352.917 138.512 473.175 132.522 528.151H107.562C104.367 492.24 104.9 385.503 105.566 336.624H99.908L38.3406 528.151C31.0605 527.241 18.1771 526.744 12.1865 526.156Z",
    fill: "#6066AB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M106.352 563.25L109.096 539.165L135.081 540.111L135.6 546.836L164.581 563.413C169.977 566.108 171.119 567.127 159.941 568.28L127.362 566.199L108.263 565.475C107.1 565.431 106.22 564.406 106.352 563.25Z",
    fill: "#263238"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M116.47 175.006C116.358 167.965 116.47 160.697 116.47 160.697C116.47 160.697 126.501 159.18 127.016 147.297C127.531 135.414 125.894 111.865 125.894 111.865C112.993 106.755 98.5204 108.686 89.5454 119.247L90.8917 176.028C91.0038 182.614 96.8376 187.724 103.793 187.497C110.861 187.27 116.47 181.706 116.47 175.006Z",
    fill: "#FFBE9D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M120.729 131.931C120.729 132.726 120.169 133.407 119.271 133.52C118.486 133.52 117.813 132.953 117.7 132.158C117.7 131.363 118.261 130.681 119.159 130.568C119.944 130.568 120.617 131.136 120.729 131.931Z",
    fill: "#263238"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M121.836 131.6C121.536 131.708 120.916 130.404 119.45 129.829C116.521 128.931 116.427 129.389 116.525 129.184C116.472 129.033 116.822 128.823 117.374 128.709C117.926 128.596 118.931 128.573 119.842 129.009C120.753 129.445 121.314 130.091 121.673 130.64C121.931 131.141 121.986 131.546 121.836 131.6Z",
    fill: "#263238"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M103.556 133.271C103.556 134.066 102.995 134.747 102.097 134.861C101.312 134.861 100.639 134.293 100.527 133.498C100.527 132.703 101.088 132.022 101.985 131.908C102.883 131.795 103.556 132.476 103.556 133.271Z",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M104.508 130.723C104.413 131.028 102.999 130.734 101.655 131.555C100.259 132.275 99.5271 133.548 99.3753 133.498C99.2236 133.449 99.2668 133.043 99.5094 132.535C99.752 132.026 100.341 131.211 101.239 130.748C102.136 130.285 102.99 130.228 103.645 130.274C104.2 130.371 104.555 130.57 104.508 130.723Z",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M111.685 143.844C111.684 143.731 112.693 143.609 114.261 143.37C114.71 143.367 115.046 143.251 115.156 142.909C115.265 142.568 115.037 142.115 114.809 141.663C114.353 140.644 114.009 139.625 113.551 138.492C111.835 134.076 110.46 130.339 110.685 130.337C110.908 130.222 112.394 133.845 114.223 138.26C114.68 139.392 115.024 140.412 115.481 141.43C115.596 141.884 115.937 142.449 115.717 143.019C115.608 143.36 115.273 143.59 115.048 143.591C114.825 143.707 114.601 143.708 114.376 143.71C112.694 143.836 111.685 143.844 111.685 143.844Z",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M116.471 160.583C116.471 160.583 106.239 163.04 98.4984 158.498C98.4984 158.498 104.691 164.671 116.359 163.422L116.471 160.583Z",
    fill: "#EB996E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M109.682 148.962C110.137 148.801 111.3 148.605 112.991 148.605C114.911 148.607 116.187 148.628 116.335 148.801C116.408 148.887 116.215 149.352 115.618 149.862C115.021 150.372 114.021 150.929 112.896 150.995C111.698 150.974 110.692 150.489 110.249 149.971C109.721 149.526 109.596 149.035 109.682 148.962Z",
    fill: "#263238"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M91.231 114.223C98.1156 118.953 112.367 121.172 121.357 119.404C119.924 118.452 113.548 117.196 111.997 116.288C116.948 117.676 123.829 119.556 128.966 117.887C129.553 117.665 130.257 117.399 130.637 116.984C131.206 116.362 131.01 115.486 130.858 114.728C130.087 111.625 128.562 106.721 126.97 103.928C125.379 101.135 122.163 98.4618 118.935 97.3733C114.705 96.1201 109.447 96.0482 104.942 97.6147C101.258 98.8708 97.4745 100.572 94.6818 103.121C91.7718 105.714 90.3986 110.6 91.0964 113.866",
    fill: "#263238"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7878 136.386C81.0421 133.477 79.9906 129.007 79.8784 127.076C79.5418 121.058 82.5899 102.099 103.232 103.802L99.4749 110.162C99.4749 110.162 107.808 123.003 93.9208 132.079C93.9208 132.079 95.2448 146.368 93.8434 149.769C93.223 151.275 90.3522 149.769 90.3522 143.369C90.3522 143.369 88.0246 143.951 82.7878 136.386Z",
    fill: "#263238"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9339 134.641C89.6999 134.414 88.5646 133.491 87.4427 134.059C86.3208 134.513 85.5639 135.251 85.1152 136.386C84.6664 137.522 84.7499 138.58 85.1986 139.829C85.6474 141.078 86.4327 142.1 87.3302 143.009C88.0033 143.69 88.6765 144.258 89.574 144.485C90.4715 144.712 91.4812 144.599 92.1543 144.031",
    fill: "#FFBE9D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4276 141.425C90.5395 141.417 90.1533 142.244 88.9054 142.112C88.3374 142.042 87.7431 141.633 87.3551 140.979C86.9758 140.439 86.6996 139.777 86.5265 138.993C86.3533 138.209 86.5158 137.399 86.7989 136.694C87.2025 136.093 87.7268 135.597 88.2861 135.554C89.4046 135.468 89.9133 136.226 89.8014 136.234C89.6983 136.356 89.2159 135.938 88.4504 136.225C87.6762 136.398 87.0838 137.469 87.4125 138.811C87.6206 140.048 88.2762 141.25 88.9648 141.424C89.8859 141.695 90.307 141.321 90.4276 141.425Z",
    fill: "#EB996E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9658 169.5L109.411 185.133L117.333 172.003L131.817 233.746L133.177 306.335H79.1631L89.9658 169.5Z",
    fill: "#CABCE8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2756 184.624C72.0334 178.574 86.365 171.54 90.6861 168.78L102.569 223.874C109.651 256.522 114.812 348.465 37.0325 352.786C41.3536 339.823 53.5967 276.087 58.9981 246.199L49.2756 184.624Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M164.505 246.2L149.382 182.103L136.778 248.36L142.18 280.768L150.822 306.695L164.505 246.2Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 255L71 288L68.5 291",
    stroke: "#DDDDED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M149.381 182.103C135.265 179.51 121.174 173.581 115.893 170.94L129.576 227.475C126.695 246.799 123.454 298.052 138.578 319.298C148.661 331.541 153.342 335.862 156.583 339.823L141.819 260.963L146.14 230.715L146.86 223.514C148.301 209.11 149.021 197.227 149.381 182.103Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11 250.177L48.8096 185L59.6123 244.415L51.6903 254.858L69.6949 288.346C64.6536 294.108 59.6123 299.149 56.3715 302.39C38.7991 293.171 18.802 263.74 11 250.177Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5625 185.5L59.4999 243.5",
    stroke: "#DDDDED",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0625 173L110.896 192L120.062 175.969",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M116.37 167.574C127 177.5 142.336 201.883 138.401 238.796L135.418 238.479C139.024 204.645 124.959 180.595 116.37 171.39V167.574Z",
    fill: "#454C6A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M121.95 244.284C124.478 242.154 127.378 234.7 118.757 221.922C107.982 205.95 103.193 201.956 94.4126 205.95C81.083 212.012 86.4308 234.301 95.2108 247.478C100.958 257.062 104.789 256.263 105.986 254.666",
    stroke: "#454C6A",
    strokeWidth: 3
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0131 168.944C90.6559 168.421 90.7535 167.477 90.231 166.834C89.7085 166.191 88.7637 166.093 88.1209 166.616L90.0131 168.944ZM92.2659 206.696C92.6781 207.414 93.5948 207.663 94.3134 207.251C95.032 206.838 95.2803 205.922 94.8681 205.203L92.2659 206.696ZM88.1209 166.616C83.2682 170.56 79.0693 183.69 92.2659 206.696L94.8681 205.203C81.8827 182.566 86.9566 171.428 90.0131 168.944L88.1209 166.616Z",
    fill: "#454C6A"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.891,
    cy: 254.562,
    r: 2.52064,
    fill: "#DDDDED"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.014,
    cy: 244.479,
    r: 2.52064,
    fill: "#DDDDED"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M135.57 244.111C136.845 244.392 138.116 244.333 139.155 243.958C140.181 243.588 141.123 242.845 141.379 241.685C141.636 240.525 141.095 239.454 140.321 238.686C139.537 237.908 138.409 237.318 137.135 237.036C135.861 236.754 134.589 236.813 133.55 237.188C132.525 237.558 131.583 238.302 131.326 239.461C131.07 240.621 131.61 241.693 132.384 242.461C133.168 243.239 134.296 243.829 135.57 244.111Z",
    fill: "#DDDDED",
    stroke: "#454C6A",
    strokeWidth: 2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 542.794L13.8895 530.966L35.9043 534.54L34.7466 542.495L31.9139 573.867L19.6879 581.57C14.9974 584.525 8.79813 583.1 5.86819 578.394L0.782216 570.225L12.6665 542.794Z",
    fill: "#263238"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9983 336.583C58.9983 336.583 37.6486 432.481 21.5488 523.11",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8787 307.415L57.5576 301.653L69.4406 289.05C71.2411 289.77 72.6815 290.491 75.9223 291.571C75.3461 294.452 65.8397 303.814 61.8787 307.415Z",
    fill: "#FFBE9D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7234 286.89C75.3228 293.011 67.5688 306.479 55.7578 311.376",
    stroke: "#DDDDED",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M418.071 528.814L437.493 527.304L437.278 545.827L418.885 546.791L418.071 528.814Z",
    fill: "#C9837A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M443.708 546.126L463.185 545.735L464.306 527.525L443.819 528.359L443.708 546.126Z",
    fill: "#C9837A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M408.832 535.653C398.849 452.867 395.811 382.652 395.811 325.872H486.611C484.875 391.754 478.654 492.743 472.721 535.653H408.832Z",
    fill: "#CABCE8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M440.688 535.653V355.095",
    stroke: "#3F4690",
    strokeOpacity: 0.3
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M456.412 292.883C460.065 291.331 498.602 274.907 498.589 271.92C498.62 271.154 493.55 259.499 487.655 250.727L509.05 238.202C518.703 251.797 525.303 273.534 522.004 279.452C510.548 300.206 461.392 311.071 461.392 311.071C461.392 311.071 449.36 313.773 441.708 310.637C439.398 309.634 438.602 306.564 438.602 306.564L438.085 304.474C439.03 304.599 451.826 301.934 448.66 298.531C445.538 295.039 439.281 296.66 439.63 293.848C439.98 291.035 451.398 293.778 451.398 293.778C454.309 293.304 455.695 292.979 456.412 292.883Z",
    fill: "#C9837A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M390.624 347.388C390.883 343.428 394.245 268.991 395.835 255.305L373.371 255.044C370.24 273.688 373.396 349.237 373.396 349.237C373.396 349.237 373.231 360.938 378.716 367.127C379.829 368.331 382.682 369.965 384.539 370.959C385.253 371.341 386.075 370.743 385.951 369.943L385.729 368.514C385.3 367.662 385.373 356.139 386.939 356.661C388.504 359.792 386.449 364.806 388.989 363.548C391.528 362.29 390.389 352.417 390.389 352.417C390.592 349.355 390.77 348.097 390.624 347.388Z",
    fill: "#C9837A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M438.987 565.428L438.645 542.694L416.231 542.661L415.214 548.448L389.506 561.806C384.639 563.956 382.965 564.798 392.474 566.158L420.652 565.429L438.987 565.428Z",
    fill: "#263238"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M441.447 565.428L441.79 542.694L464.203 542.661L465.221 548.448L491.535 561.806C496.402 563.956 497.469 564.798 487.961 566.158L459.783 565.429L441.447 565.428Z",
    fill: "#263238"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M420.725 148.576C418.214 141.583 410.966 141.012 407.656 141.601C408.289 146.598 411.913 147.154 414.229 149.399C409.032 150.057 407.197 154.013 406.93 155.909C412.574 156.378 423.235 155.569 420.725 148.576Z",
    fill: "#3F4690"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M450.602 189.344C450.498 182.856 450.602 176.16 450.602 176.16C450.602 176.16 447.512 169.765 449.063 158.883C450.613 148.524 446.76 131.167 446.76 131.167C434.873 126.458 434.062 128.237 425.793 137.968L427.033 190.285C427.137 196.354 432.512 201.063 438.921 200.854C445.433 200.644 450.602 195.517 450.602 189.344Z",
    fill: "#C9837A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M456.369 155.751C456.369 166.703 452.634 182.887 438.626 182.887C424.619 182.887 420.884 166.703 420.884 155.751C420.884 144.8 428.827 140.096 438.626 140.096C448.425 140.096 456.369 144.8 456.369 155.751Z",
    fill: "#6D3932"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M458.456 157.839C458.456 168.791 454.281 179.756 438.626 179.756C422.971 179.756 418.796 168.791 418.796 157.839C418.796 156.277 418.976 135.971 419.318 134.514C421.37 125.749 429.236 129.659 438.626 129.659C448.784 129.659 457.158 126.861 458.319 136.707C458.409 137.476 458.456 157.045 458.456 157.839Z",
    fill: "#C9837A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M457.733 149.631C458.44 149.404 459.21 149.404 459.853 149.972C460.495 150.425 461.137 151.333 461.394 152.467C461.651 153.601 461.651 154.962 461.394 156.21C461.137 157.458 460.688 158.479 460.174 159.386C459.789 160.067 459.403 160.634 458.889 160.861C458.376 161.087 457.797 160.974 457.412 160.407",
    fill: "#AC645B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M458.465 157.264C458.403 157.264 458.653 158.015 459.34 157.8C459.652 157.693 459.965 157.264 460.152 156.62C460.34 156.084 460.465 155.44 460.527 154.689C460.59 153.938 460.465 153.186 460.277 152.543C460.027 152.006 459.715 151.577 459.403 151.577C458.778 151.577 458.528 152.328 458.59 152.328C458.653 152.435 458.903 152.006 459.34 152.221C459.777 152.328 460.152 153.294 460.027 154.581C459.965 155.762 459.652 156.942 459.278 157.157C458.778 157.479 458.528 157.157 458.465 157.264Z",
    fill: "#6D3932"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M427.464 150.993C427.487 151.79 428.068 152.456 428.97 152.545C429.757 152.522 430.415 151.934 430.505 151.135C430.482 150.339 429.901 149.672 428.999 149.584C428.212 149.606 427.554 150.194 427.464 150.993Z",
    fill: "#263238"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M426.114 149.924C426.346 150.145 427.444 149.203 429.02 149.272C432.067 149.641 431.968 150.1 431.961 149.872C432.07 149.755 431.836 149.42 431.377 149.092C430.918 148.763 430.006 148.334 428.994 148.362C427.983 148.391 427.206 148.754 426.654 149.112C426.214 149.466 425.999 149.813 426.114 149.924Z",
    fill: "#263238"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M446.062 151.063C446.062 151.86 446.625 152.542 447.524 152.656C448.311 152.656 448.985 152.087 449.098 151.291C449.098 150.494 448.536 149.811 447.636 149.698C446.737 149.584 446.062 150.267 446.062 151.063Z",
    fill: "#263238"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M444.97 149.925C445.195 150.153 446.319 149.242 447.893 149.356C449.467 149.356 450.704 150.153 450.816 150.039C450.928 149.925 450.704 149.584 450.254 149.242C449.804 148.901 448.905 148.446 447.893 148.446C446.881 148.446 446.094 148.787 445.532 149.129C445.082 149.47 444.858 149.811 444.97 149.925Z",
    fill: "#263238"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M436.094 162.33C436.126 162.221 437.13 162.39 438.705 162.606C439.138 162.73 439.493 162.713 439.695 162.416C439.898 162.119 439.807 161.62 439.717 161.12C439.567 160.012 439.525 158.934 439.407 157.716C439.011 152.985 438.75 149.003 438.966 149.065C439.213 149.018 439.614 152.921 440.118 157.684C440.236 158.901 440.278 159.979 440.428 161.087C440.41 161.556 440.577 162.196 440.204 162.681C440.002 162.978 439.615 163.104 439.399 163.042C439.151 163.089 438.935 163.027 438.719 162.965C437.067 162.609 436.094 162.33 436.094 162.33Z",
    fill: "#263238"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M456.369 151.577L459.5 148.446L461.065 150.011",
    stroke: "#272848",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M442.2 168.665C442.045 168.519 440.674 169.727 438.72 169.719C436.766 169.71 435.624 168.3 435.451 168.47C435.365 168.556 435.502 169.018 436.043 169.529C436.584 170.039 437.53 170.598 438.666 170.669C439.889 170.654 440.975 170.177 441.492 169.665C442.087 169.225 442.277 168.738 442.2 168.665Z",
    fill: "#263238"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    r: 3.49852,
    transform: "matrix(-1 0 0 1 447.687 160.606)",
    fill: "#6D3932"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    r: 3.49852,
    transform: "matrix(-1 0 0 1 428.557 160.606)",
    fill: "#6D3932"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 428.19,
    cy: 151.577,
    r: 6.8058,
    stroke: "#272848"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 449.063,
    cy: 151.577,
    r: 6.8058,
    stroke: "#272848"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 435.495,
    y: 150.533,
    width: 6.26212,
    height: 1.04369,
    fill: "#272848"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.097 124.37C425.084 123.777 421.412 127.976 420.068 130.608C419.737 131.26 419.501 132.072 419.228 133.01C419.024 133.71 418.801 134.479 418.502 135.305C417.803 137.238 417.458 140.523 417.98 142.089C418.208 142.772 418.25 145.836 418.25 145.836C423.748 144.543 427.439 140.414 429.451 137.462C433.782 140.808 438.937 142.903 445.1 143.19C446.674 143.51 451.394 144.472 452.402 144.35C453.472 144.732 456.557 144.869 457.998 144.836C458.573 144.766 459.263 144.682 459.695 144.393C460.325 143.973 460.358 143.178 460.387 142.48C460.388 142.459 460.389 142.439 460.39 142.419C460.382 139.466 459.53 134.371 458.717 131.515C457.904 128.66 456.17 125.917 453.515 124.23C449.997 122.176 445.426 120.977 441.041 121.391C437.461 121.707 433.693 122.4 430.628 124.072C430.448 124.167 430.271 124.266 430.097 124.37Z",
    fill: "#FFBE9D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M417.752 146.88C421.405 128.616 448.636 130.45 458.863 133.589C460.633 118.857 443.578 116.136 434.829 116.618C414.582 118.653 413.056 139.574 417.752 146.88Z",
    fill: "#3F4690"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M419.519 149.631C418.812 149.404 418.041 149.404 417.399 149.972C416.757 150.425 416.115 151.333 415.858 152.467C415.601 153.601 415.601 154.962 415.858 156.21C416.115 157.458 416.564 158.479 417.078 159.386C417.463 160.067 417.849 160.634 418.363 160.861C418.876 161.087 419.454 160.974 419.84 160.407",
    fill: "#AC645B"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M418.787 157.264C418.849 157.264 418.599 158.015 417.912 157.8C417.6 157.693 417.287 157.264 417.1 156.62C416.912 156.084 416.787 155.44 416.725 154.689C416.662 153.938 416.787 153.186 416.975 152.543C417.225 152.006 417.537 151.577 417.849 151.577C418.474 151.577 418.724 152.328 418.662 152.328C418.599 152.435 418.349 152.006 417.912 152.221C417.475 152.328 417.1 153.294 417.225 154.581C417.287 155.762 417.6 156.942 417.974 157.157C418.474 157.479 418.724 157.157 418.787 157.264Z",
    fill: "#6D3932"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M421.406 151.055L418.275 147.924L416.709 149.489",
    stroke: "#272848",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M395.74 193.787L428.185 186.018L438.239 230.802L447.378 186.018C454.233 186.476 467.486 190.131 479.367 193.787C490.7 201.099 516.356 237.681 522.515 263.705H491.446L479.367 242.876V271.931L500.845 345.962L444.636 347.79L441.895 322.656L436.411 347.79H383.401L398.481 271.931L397.827 255.474L396.975 263.705C387.378 262.791 375.305 261.877 369.821 260.963C372.327 225.157 388.58 203.536 395.74 193.787Z",
    fill: "#3F4690"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M426.357 187.846L408.535 194.244C413.105 198.052 422.153 205.851 421.788 206.583C421.422 207.314 415.542 210.543 412.648 212.066L436.868 232.174L441.438 321.285",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M440.523 229.889L459.26 212.523L449.206 206.126L464.743 194.244L448.292 186.932",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M476.467 258.596L430.026 264.624L443.15 322.571L489.591 316.544L476.467 258.596Z",
    fill: "#DDDDED"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M474.015 261.589L433.305 266.873L444.81 317.668L485.52 312.385L474.015 261.589Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M461.072 260.607C460.601 259.216 459.214 258.35 457.757 258.539L448.101 259.793C446.173 260.043 444.956 261.994 445.58 263.836C446.051 265.227 447.438 266.092 448.895 265.903L458.551 264.65C460.479 264.4 461.696 262.448 461.072 260.607Z",
    fill: "#263238"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    r: 3.69716,
    transform: "matrix(-0.991682 0.12871 0.12871 0.991682 452.93 259.166)",
    stroke: "#263238"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M438.5 272L471 268",
    stroke: "#DDDDED"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M440.5 277L473 273",
    stroke: "#DDDDED"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M441.5 282L474 278",
    stroke: "#DDDDED"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M442.5 287L475 283",
    stroke: "#DDDDED"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M443.5 292L476 288",
    stroke: "#DDDDED"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M458 292C461.653 290.449 498.601 274.907 498.588 271.92L522.003 279.452C510.547 300.206 461.391 310.071 461.391 310.071C461.391 310.071 449.5 313 441.707 310.637C439.397 309.634 438.601 306.564 438.601 306.564L438.436 305.898C438.267 305.214 438.841 304.456 439.54 304.373C443.051 303.957 451.266 302.333 448.66 299.531C444.5 301.5 440.15 303.812 440.5 301C440.849 298.188 451.397 293.778 451.397 293.778C454.5 292.5 457.283 292.096 458 292Z",
    fill: "#C9837A"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M149 189C149 211.5 145.5 246.5 142.5 260.5C142.5 268.5 146.667 291.667 150 304",
    stroke: "#DDDDED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M227.305 431.965L254.914 430.518L243.708 548.266L226.085 549.189L227.305 431.965Z",
    fill: "#FFBE9D"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M309.664 431.965L282.055 430.518L293.261 548.266L310.884 549.189L309.664 431.965Z",
    fill: "#FFBE9D"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M241 187H293L306.639 312.676C306.832 314.451 305.442 316 303.657 316H234.242C232.493 316 231.115 314.511 231.251 312.768L241 187Z",
    fill: "#ED737C"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M231 306H303L326.394 441.49C326.711 443.323 325.299 445 323.438 445H214.463C212.636 445 211.233 443.381 211.493 441.573L231 306Z",
    fill: "#3F4690"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M245.346 567.046L245.017 545.264L223.542 545.233L222.567 550.777L197.936 563.577C193.272 565.636 191.668 566.443 200.779 567.746L227.777 567.047L245.346 567.046Z",
    fill: "#263238"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M291.727 567.046L292.055 545.264L313.53 545.233L314.505 550.777L339.718 563.577C344.381 565.636 345.404 566.443 336.293 567.746L309.295 567.047L291.727 567.046Z",
    fill: "#263238"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M227.454 187.89L257 181L261.098 186.315L264.721 180.017L264.278 426.02C264.276 427.123 263.381 428.017 262.278 428.017H201.468C200.192 428.017 199.242 426.837 199.514 425.59L228.588 292.257C211.836 288.247 200.999 267.87 204.08 260.579L227.454 187.89Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M309.682 187.621L279.5 180.5L277.176 186.315L273.553 180.017L273.997 426.02C273.999 427.123 274.893 428.017 275.997 428.017H336.806C338.082 428.017 339.032 426.837 338.76 425.59L309.63 292C326.608 288.221 334.3 265.927 331.194 258.579L311.145 189.014C310.945 188.32 310.385 187.787 309.682 187.621Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M260.384 117.445C253.196 118.288 253.366 115.53 252.628 117.263C251.891 118.997 247.93 117.54 247.832 119.448C247.734 121.355 247.72 120.303 246.877 122.043C245.457 124.661 246.216 127.164 245.442 130.061C244.587 133.386 242.639 136.414 240.88 138.898C239.707 140.553 237.101 144.832 236.249 149.772C235.109 161.73 237.659 166.117 238.698 167.746C241.342 171.712 246.267 173.432 250.983 173.367C255.699 173.303 275.082 168.003 262.894 160.386",
    fill: "#263238"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M256.515 182.432C256.622 175.671 256.515 168.693 256.515 168.693C256.515 168.693 248.005 167.167 246.389 155.827C244.774 145.033 247.466 121.809 247.466 121.809C259.854 116.902 273.749 118.756 282.366 128.896L281.074 183.413C280.966 189.737 275.365 194.643 268.686 194.425C261.9 194.207 256.515 188.865 256.515 182.432Z",
    fill: "#FFBE9D"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M249.729 141.816C249.729 142.579 250.268 143.233 251.13 143.342C251.884 143.342 252.53 142.797 252.638 142.034C252.638 141.271 252.099 140.617 251.238 140.508C250.483 140.508 249.837 141.053 249.729 141.816Z",
    fill: "#263238"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M247.466 140.727C247.681 140.945 248.759 140.072 250.267 140.181C253.175 140.617 253.067 141.054 253.067 140.836C253.175 140.727 252.959 140.399 252.529 140.072C252.098 139.745 251.236 139.309 250.267 139.309C249.297 139.309 248.543 139.636 248.005 139.963C247.574 140.29 247.358 140.617 247.466 140.727Z",
    fill: "#263238"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M265.563 142.362C265.563 143.125 266.102 143.779 266.964 143.888C267.718 143.888 268.364 143.343 268.472 142.58C268.472 141.816 267.933 141.162 267.071 141.053C266.21 140.944 265.563 141.598 265.563 142.362Z",
    fill: "#263238"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M263.517 141.271C263.732 141.489 264.809 140.617 266.317 140.726C267.825 140.726 269.01 141.489 269.118 141.38C269.226 141.271 269.01 140.944 268.579 140.617C268.148 140.29 267.287 139.854 266.317 139.854C265.348 139.854 264.594 140.181 264.055 140.508C263.624 140.835 263.409 141.162 263.517 141.271Z",
    fill: "#263238"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M257.808 151.385C257.808 151.276 256.838 151.167 255.33 150.949C254.899 150.949 254.576 150.84 254.468 150.512C254.361 150.185 254.576 149.749 254.792 149.313C255.222 148.332 255.546 147.351 255.976 146.26C257.592 142.008 258.885 138.41 258.669 138.41C258.454 138.301 257.054 141.79 255.33 146.042C254.899 147.132 254.576 148.114 254.145 149.095C254.038 149.531 253.714 150.076 253.93 150.622C254.038 150.949 254.361 151.167 254.576 151.167C254.792 151.276 255.007 151.276 255.222 151.276C256.838 151.385 257.808 151.385 257.808 151.385Z",
    fill: "#263238"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M256.517 168.585C256.517 168.585 264.057 169.13 271.489 164.769C271.489 164.769 267.827 172.51 256.624 171.311L256.517 168.585Z",
    fill: "#EB996E"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M260.869 155.918C260.689 155.823 259.728 157.287 257.921 157.775C256.113 158.262 254.7 157.248 254.584 157.45C254.526 157.551 254.769 157.944 255.399 158.278C256.029 158.612 257.044 158.889 258.112 158.666C259.238 158.343 260.12 157.627 260.468 157.022C260.907 156.465 260.959 155.966 260.869 155.918Z",
    fill: "#263238"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M275.77 120.884C271.835 126.544 276.28 129.04 268.825 130.298C267.464 130.751 263.078 130.744 262.171 130.744C260.587 130.744 251.398 131.06 248.863 131.06C248.346 131.06 246.743 130.953 246.328 130.744C245.707 130.429 245.481 129.155 245.378 128.526C245.067 125.905 245.226 125.601 245.64 122.981C246.054 120.36 247.296 117.74 249.471 115.958C252.37 113.757 256.408 113.129 260.342 113.024C263.552 112.919 266.969 113.129 269.868 114.282C272.871 115.434 275.356 117.845 275.77 120.57",
    fill: "#263238"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M291.184 145.055C291.722 142.111 292.153 139.385 292.261 137.531C292.584 131.753 289.044 112.432 269.224 114.068L268.363 120.174C268.363 120.174 265.347 141.108 278.165 141.217C278.165 141.217 276.618 155.409 284.735 153.538C284.628 153.538 289.891 151.27 291.184 145.055Z",
    fill: "#263238"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M278.166 141.218C279.35 141 280.643 141 281.72 141.545C282.797 141.981 283.874 142.853 284.305 143.944C284.736 145.034 284.736 146.342 284.305 147.542C283.874 148.741 283.12 149.722 282.259 150.595C281.612 151.249 280.966 151.794 280.104 152.012C279.243 152.23 278.273 152.121 277.627 151.576",
    fill: "#FFBE9D"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M278.703 148.632C278.596 148.632 279.027 149.395 280.211 149.177C280.75 149.068 281.289 148.632 281.612 147.978C281.935 147.433 282.15 146.779 282.258 146.015C282.366 145.252 282.15 144.489 281.827 143.835C281.396 143.289 280.858 142.853 280.319 142.853C279.242 142.853 278.811 143.617 278.919 143.617C279.027 143.726 279.457 143.289 280.211 143.507C280.965 143.617 281.612 144.598 281.396 145.906C281.289 147.106 280.75 148.305 280.104 148.523C279.242 148.85 278.811 148.523 278.703 148.632Z",
    fill: "#EB996E"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M279.144 127.771C278.054 129.135 278.944 124.136 279.668 125.616C280.495 127.12 280.128 121.055 281.107 122.379C282.085 123.703 282.318 119.631 282.022 121.297C281.75 122.86 283.63 124.028 283.461 125.616C284.103 129.685 287.519 122.189 290.687 129.159C294.806 135.813 295.757 138.031 301.777 145.952C302.74 147.22 304.312 150.071 304.629 151.656C307.797 164.647 299.977 170.696 296.973 172.355C293.867 173.99 290.189 173.965 286.89 173.272C280.231 171.3 278.33 166.865 278.647 161.478C278.647 157.359 283.42 151.294 284.35 148.804C288.699 137.153 284.606 148.78 287.24 136.603",
    fill: "#263238"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    r: 3.35208,
    transform: "matrix(-1 0 0 1 267.121 152.059)",
    fill: "#EB996E"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M309 295H292V321C292 326.523 296.477 331 302 331H317",
    stroke: "#DDDDED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M229 295H246V321C246 326.523 241.523 331 236 331H221",
    stroke: "#DDDDED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M230 288.5L240 230",
    stroke: "#DDDDED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M308 288.5L298 230",
    stroke: "#DDDDED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBg);
export default __webpack_public_path__ + "static/media/heroBg.ab8399db1c391c58c79835760a6c0aeb.svg";
export { ForwardRef as ReactComponent };